import { DynamicYieldService } from './dynamicYield.service';
import { PreQualFormEventConstant, DynamicYieldEventName, PersonalDetailsPrequalUDOConstants, CategoryL3, checkout_Info, vehicle_Info } from './../enum/analytics.enum';
import { IPreQualEvent } from './../interfaces/analytics.interface';
import { Inject, Injectable } from '@angular/core';
import { UDO } from '../../global';
import {
  CategoryL1, CategoryL2, FormActualName,
  UDOConstant, EventLabel, EventCategory, EventAction, EditEvent, FormName,
  PersonalDetailsUDOConstants
} from '../enum/analytics.enum';
import { ComponentName } from '../enum/component-name.enum';
import { TealiumService } from './tealium.service';
import { AnalyticsBuynowEventService } from './analytics-buynow-event.service';
import { Actions } from '../actions/analytics.action';
import { FormInfoService } from './form-info.service';
import { IConfig } from '../interfaces/config.interface';
import { NotificationsService } from './notifications.service';
import { CreditAppService } from './credit-app.service';


@Injectable({
  providedIn: 'root'
})
export class FormInfoBuynowService extends FormInfoService {
  // tslint:disable-next-line: variable-name
  form_name: string;
  isNewVDP: boolean = false;

  constructor(public tealium: TealiumService, public analyticsEventService: AnalyticsBuynowEventService,
              @Inject('config') public config: IConfig, public notificationService: NotificationsService,
              public dynamicYieldService: DynamicYieldService,public creditAppService: CreditAppService) {
    super(tealium, analyticsEventService, config, notificationService, dynamicYieldService, creditAppService);

    this.process_actual_name = PersonalDetailsUDOConstants.ProcessActualName;
    this.process_name = PersonalDetailsUDOConstants.ProcessName;
    this.form_name = FormName.PersonalDetails;
    this.form_actual_name = FormActualName.PersonalDetails;
    this.setCategoryL1();
    this.setCategoryL2();
    this.setCategoryL3();
    this.setCategoryL4();
    
    this.isNewVDP = window.location.search.toLowerCase().indexOf('?isnewvdp=true') === -1 ? false : true;
  }

  setCategoryL1() {
    this.category_l1 = CategoryL1.OnlineBuying;
  }

  setCategoryL2() {
    this.category_l2 = CategoryL2.PersonalDetails;
  }
  setCategoryL3() {
    this.category_l3 = UDO.NotSet;
  }
  setCategoryL4() {
    this.category_l4 = UDO.NotSet;
  }

  setPageSubmit(action: Actions) {
    super.setPageSubmit(action);

    switch (action.payload.componentName) {
      case ComponentName.PersonalInfoComponent:
        this.reportFormPageNSubmit();
        break;
    }
  }


  reportPrequalFormEvent(data: IPreQualEvent) {
    try {

      this.category_l3 = data.isBuyNowPrequalSelected ? 'Prequal' : '(not set)';
      const preQualFormEvent: any = {};
      const tealiumVehicleInfo: any = (window as any).buynow && (window as any).buynow.Tealium
        ? (window as any).buynow.Tealium.vehicleInfo || {}
        : {};
      preQualFormEvent.category_l1 = this.category_l1;
      preQualFormEvent.category_l2 = this.category_l2;
      preQualFormEvent.category_l3 = this.category_l3;
      preQualFormEvent.category_l4 = this.category_l4;
      preQualFormEvent.pagegroup = UDOConstant.personalDetailsPageGroup;
      preQualFormEvent.process_actual_name = this.process_actual_name;
      preQualFormEvent.process_name = this.process_name;
      if (data.type !== PreQualFormEventConstant.SelectPrequalify && data.type !== PreQualFormEventConstant.PreQualConfirmationLoaded) {
        preQualFormEvent.form_name = this.form_name;
        preQualFormEvent.form_actual_name = this.form_actual_name;
      }
      switch (data.type) {
        case PreQualFormEventConstant.FormStarted:
          preQualFormEvent.event = EditEvent.FormStarted;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.LeadSubmissionDigitalRetailingFormStarted;
          preQualFormEvent.event_label = EventLabel.PersonalDetailsFormStarted;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.form_started = UDOConstant.UnityFlag;
          preQualFormEvent.enh_action = UDOConstant.Checkout;
          preQualFormEvent.enh_vehic_brand = tealiumVehicleInfo.enh_vehic_brand || '';
          preQualFormEvent.enh_vehic_id = tealiumVehicleInfo.enh_vehic_id || '';
          preQualFormEvent.enh_vehic_name = tealiumVehicleInfo.enh_vehic_name || '';
          preQualFormEvent.enh_vehic_price = tealiumVehicleInfo.enh_vehic_price || '';
          preQualFormEvent.enh_vehic_variant = tealiumVehicleInfo.enh_vehic_variant || '';
          preQualFormEvent.enh_vehic_category = tealiumVehicleInfo.enh_vehic_category || '';
          preQualFormEvent.enh_vehic_discount = tealiumVehicleInfo.enh_vehic_discount
            && tealiumVehicleInfo.enh_vehic_discount.lockedDiscount
              ? Math.abs(Number(tealiumVehicleInfo.enh_vehic_discount.lockedDiscount)) || 0
              : 0;
          preQualFormEvent.enh_checkout_step = 1;
         // preQualFormEvent.non_interaction = true;
          break;

        case PreQualFormEventConstant.FormSubmitInitiated:

          preQualFormEvent.submit_initiated = UDOConstant.UnityFlag;
          preQualFormEvent.event = EditEvent.FormSubmitInitiated;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.LeadSubmissionDigitalRetailingSubmitInitiated;
          preQualFormEvent.event_label = EventLabel.PersonalDetailsSubmitInitiated;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          break;

        case PreQualFormEventConstant.FormSuccess:
          preQualFormEvent.event = EditEvent.FormSuccess;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypeDigitalRetailingFormSuccess;
          preQualFormEvent.event_label = EventLabel.PersonalDetailsFormSuccess;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.form_success = UDOConstant.UnityFlag;
          preQualFormEvent.enh_action = 'purchase';
          preQualFormEvent.enh_vehic_brand = tealiumVehicleInfo.enh_vehic_brand || '';
          preQualFormEvent.enh_vehic_id = tealiumVehicleInfo.enh_vehic_id || '';
          preQualFormEvent.enh_vehic_name = tealiumVehicleInfo.enh_vehic_name || '';
          preQualFormEvent.enh_vehic_price = tealiumVehicleInfo.enh_vehic_price || '';
          preQualFormEvent.enh_vehic_variant = tealiumVehicleInfo.enh_vehic_variant || '';
          preQualFormEvent.enh_transaction_id = Math.random().toString(36).substring(5);
          preQualFormEvent.enh_vehic_category = tealiumVehicleInfo.enh_vehic_category || '';
          preQualFormEvent.enh_vehic_discount = tealiumVehicleInfo.enh_vehic_discount
            && tealiumVehicleInfo.enh_vehic_discount.unlockedDiscount
              ? Math.abs(Number(tealiumVehicleInfo.enh_vehic_discount.unlockedDiscount)) || 0
              : 0;
              // this.dynamicYieldService.track(DynamicYieldEventName.Purchase, {
              //   enh_vehic_id: tealiumVehicleInfo.enh_vehic_id,
              //   enh_vehic_price: tealiumVehicleInfo.enh_vehic_price,
              // });

              this.dynamicYieldService.track(DynamicYieldEventName.Purchase, {leadId: data.leadId});

              if(this.isNewVDP) {
                this.dynamicYieldService.track(DynamicYieldEventName.FormSuccessVDPPrequal, {
                  form_actual_name: preQualFormEvent.form_actual_name,
                  form_name: preQualFormEvent.form_name,
                  enh_action: preQualFormEvent.enh_action,
                  lead_date: new Date().toISOString(),
                  lead_hyperion: tealiumVehicleInfo.lead_hyperion,
                  lead_provider_id: '5522',
                  lead_store_name: tealiumVehicleInfo.lead_store_name,
                  lead_cust_zip: data.data.zipcode,
                  enh_booking_value: preQualFormEvent.enh_vehic_price ,
                  enh_checkout_option:checkout_Info.buyNow_checkout_option,
                  enh_vehic_brand:preQualFormEvent.enh_vehic_brand,
                  enh_vehic_category: preQualFormEvent.enh_vehic_category,
                  enh_vehic_discount:preQualFormEvent.enh_vehic_discount,
                  enh_vehic_id: preQualFormEvent.enh_vehic_id,
                  enh_vehic_list:vehicle_Info.vehic_list,
                  enh_vehic_name:preQualFormEvent.enh_vehic_name,
                  enh_vehic_price:preQualFormEvent.enh_vehic_price,
                  enh_vehic_quantity:vehicle_Info.vehic_quantity,
                  enh_vehic_variant:preQualFormEvent.enh_vehic_variant
                });
              } else {
                this.dynamicYieldService.track(DynamicYieldEventName.FormSuccessPersonalDetails, {
                  form_actual_name: preQualFormEvent.form_actual_name,
                  form_name: preQualFormEvent.form_name,
                  enh_action: preQualFormEvent.enh_action,
                  lead_date: new Date().toISOString(),
                  lead_hyperion: tealiumVehicleInfo.lead_hyperion,
                  lead_provider_id: '5522',
                  lead_store_name: tealiumVehicleInfo.lead_store_name,
                  lead_cust_zip: data.data.zipcode,
                  enh_booking_value: preQualFormEvent.enh_vehic_price ,
                  enh_checkout_option:checkout_Info.buyNow_checkout_option,
                  enh_vehic_brand:preQualFormEvent.enh_vehic_brand,
                  enh_vehic_category: preQualFormEvent.enh_vehic_category,
                  enh_vehic_discount:preQualFormEvent.enh_vehic_discount,
                  enh_vehic_id: preQualFormEvent.enh_vehic_id,
                  enh_vehic_list:vehicle_Info.vehic_list,
                  enh_vehic_name:preQualFormEvent.enh_vehic_name,
                  enh_vehic_price:preQualFormEvent.enh_vehic_price,
                  enh_vehic_quantity:vehicle_Info.vehic_quantity,
                  enh_vehic_variant:preQualFormEvent.enh_vehic_variant
                });
              }
          break;

        case PreQualFormEventConstant.LeadSubmission:
          preQualFormEvent.event = EditEvent.LeadSubmission;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.LeadSubmissionDigitalRetailingLeadSubmission;
          preQualFormEvent.event_label = EventLabel.PersonalDetailsLeadSubmission;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.lead_submission = 1;
          /* istanbul ignore next */
          preQualFormEvent.lead_cust_zip = data.data.zipcode ? data.data.zipcode : this.GetCustZipcode();
          preQualFormEvent.lead_inv_type = tealiumVehicleInfo.lead_inv_type;
          preQualFormEvent.lead_hyperion = tealiumVehicleInfo.lead_hyperion;
          preQualFormEvent.lead_store_name = tealiumVehicleInfo.lead_store_name;
          preQualFormEvent.lead_make_yr = tealiumVehicleInfo.lead_make_yr;
          preQualFormEvent.lead_make = tealiumVehicleInfo.lead_make;
          preQualFormEvent.lead_model = tealiumVehicleInfo.lead_model;
          preQualFormEvent.lead_vin = tealiumVehicleInfo.lead_vin;
          preQualFormEvent.lead_provider_id = '5522';

          break;

        case PreQualFormEventConstant.SelectHomeDelivery:
          preQualFormEvent.event = EditEvent.SelectDelivery;
          preQualFormEvent.event_category = EventCategory.EngagementType;
          preQualFormEvent.event_action = EventAction.EngagementTypeDigitalRetailingClick;
          preQualFormEvent.event_label = EventLabel.SelectDelivery;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;

          break;


        case PreQualFormEventConstant.SelectPrequalify:
          preQualFormEvent.event = EditEvent.SelectPrequalify;
          preQualFormEvent.event_category = EventCategory.EngagementType;
          preQualFormEvent.event_action = EventAction.EngagementTypeDigitalRetailingClick;
          preQualFormEvent.event_label = EventLabel.SelectPreQualify;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          break;

        case PreQualFormEventConstant.PreQualConfirmationLoaded:
          preQualFormEvent.category_l3 = CategoryL3.Prequal;
          preQualFormEvent.event = EditEvent.PageLoad;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.LeadSubmissionDigitalRetailingPageLoad;
          preQualFormEvent.event_label = EventLabel.PersonalDetailsPrequalPageLoad;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.pagegroup = UDOConstant.preQualPageGroup;
          preQualFormEvent.process_actual_name = PersonalDetailsPrequalUDOConstants.ProcessActualName;
          preQualFormEvent.process_name = PersonalDetailsPrequalUDOConstants.ProcessName;
          if (data.data.prequalAmt) {
            preQualFormEvent.prequal_amount = data.data.prequalAmt.toString();
          }
          break;

        case PreQualFormEventConstant.FormFailure:
          preQualFormEvent.event = EditEvent.FormFailure;
          preQualFormEvent.event_category = EventCategory.LeadSubmission;
          preQualFormEvent.event_action = EventAction.EngagementTypeDigitalRetailingFormFailure;
          preQualFormEvent.event_label = EventLabel.PersonalDetailsFormFailure;
          preQualFormEvent.event_value = UDOConstant.UnityFlag;
          preQualFormEvent.form_failure = UDOConstant.UnityFlag;
          break;
      }
      (window as any).utag_data = preQualFormEvent;
      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportSelectDelivery() {
    console.log('FormInfoBuynowService reportSelectDelivery');
    try {
      const selectDeliveryUtag: any = {};
      selectDeliveryUtag.category_l1 = this.category_l1;
      selectDeliveryUtag.category_l2 = this.category_l2;
      selectDeliveryUtag.category_l3 = this.category_l3;
      selectDeliveryUtag.category_l4 = this.category_l4;

      selectDeliveryUtag.event = EditEvent.SelectDelivery;
      selectDeliveryUtag.event_category = EventCategory.EngagementType;
      selectDeliveryUtag.event_action = EventAction.EngagementTypeDigitalRetailingClick;
      selectDeliveryUtag.event_label = EventLabel.SelectDelivery;
      selectDeliveryUtag.event_value = UDOConstant.UnityFlag;

      selectDeliveryUtag.pagegroup = UDOConstant.personalDetailsPageGroup;
      selectDeliveryUtag.process_actual_name = this.process_actual_name;
      selectDeliveryUtag.process_name = this.process_name;
      (window as any).utag_data = selectDeliveryUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportSelectPreQualification() {
    console.log('FormInfoBuynowService reportSelectPreQualification');
    try {
      const selectPreQualUtag: any = {};
      selectPreQualUtag.category_l1 = this.category_l1;
      selectPreQualUtag.category_l2 = this.category_l2;
      selectPreQualUtag.category_l3 = this.category_l3;
      selectPreQualUtag.category_l4 = this.category_l4;

      selectPreQualUtag.event = EditEvent.SelectPrequalify;
      selectPreQualUtag.event_category = EventCategory.EngagementType;
      selectPreQualUtag.event_action = EventAction.EngagementTypeDigitalRetailingClick;
      selectPreQualUtag.event_label = EventLabel.SelectPreQualify;
      selectPreQualUtag.event_value = UDOConstant.UnityFlag;

      selectPreQualUtag.pagegroup = UDOConstant.personalDetailsPageGroup;
      selectPreQualUtag.process_actual_name = this.process_actual_name;
      selectPreQualUtag.process_name = this.process_name;
      (window as any).utag_data = selectPreQualUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }


  reportFormStarted() {
    console.log('FormInfoBuynowService reportFormStarted');
    try {
      const caFormStartedUtag: any = {};
      caFormStartedUtag.category_l1 = this.category_l1;
      caFormStartedUtag.category_l2 = this.category_l2;
      caFormStartedUtag.category_l3 = this.category_l3;
      caFormStartedUtag.category_l4 = this.category_l4;
      caFormStartedUtag.event = EditEvent.FormStarted;
      caFormStartedUtag.event_category = EventCategory.LeadSubmission;
      caFormStartedUtag.event_action = EventAction.LeadSubmissionDigitalRetailingFormStarted;
      caFormStartedUtag.event_label = EventLabel.PersonalDetailsFormStarted;
      caFormStartedUtag.event_value = UDOConstant.UnityFlag;
      caFormStartedUtag.form_started = UDOConstant.UnityFlag;
      caFormStartedUtag.form_name = this.form_name;
      caFormStartedUtag.form_actual_name = this.form_actual_name;
      caFormStartedUtag.pagegroup = UDOConstant.personalDetailsPageGroup;
      caFormStartedUtag.process_actual_name = this.process_actual_name;
      caFormStartedUtag.process_name = this.process_name;
      const tealiumVehicleInfo: any = (window as any).buynow.Tealium.vehicleInfo || {};
      caFormStartedUtag.enh_action = UDOConstant.Checkout;
      caFormStartedUtag.enh_vehic_brand = tealiumVehicleInfo.enh_vehic_brand || '';
      caFormStartedUtag.enh_vehic_id = tealiumVehicleInfo.enh_vehic_id || '';
      caFormStartedUtag.enh_vehic_name = tealiumVehicleInfo.enh_vehic_name || '';
      caFormStartedUtag.enh_vehic_price = tealiumVehicleInfo.enh_vehic_price || '';
      caFormStartedUtag.enh_vehic_variant = tealiumVehicleInfo.enh_vehic_variant || '';
      caFormStartedUtag.enh_checkout_step = 1;
      (window as any).utag_data = caFormStartedUtag;

      this.tealium.link((window as any).utag_data);
    } catch (error) {
      console.log(error);
    }
  }

  reportPreQualComponentLoaded(data: IPreQualEvent) {
    console.log('FormInfoBuynowService reportPreQualComponentLoaded');
    try {

      const preQualPageLoad: any = {};
      this.category_l3 = data.isBuyNowPrequalSelected ? 'Prequal' : '(not set)';
      preQualPageLoad.category_l1 = this.category_l1;
      preQualPageLoad.category_l2 = this.category_l2;
      preQualPageLoad.category_l3 = this.category_l3;
      preQualPageLoad.category_l4 = this.category_l4;
      preQualPageLoad.event = EditEvent.FormLoad;
      preQualPageLoad.event_category = EventCategory.LeadSubmission;
      preQualPageLoad.event_action = EventAction.LeadSubmissionDigitalRetailingFormLoad;
      preQualPageLoad.event_label = EventLabel.PersonalDetailsFormLoad;
      preQualPageLoad.event_value = UDOConstant.UnityFlag;
      preQualPageLoad.form_page_load = UDOConstant.UnityFlag;
      preQualPageLoad.form_name = FormName.PersonalDetails;
      preQualPageLoad.form_actual_name = FormActualName.PersonalDetails;
      preQualPageLoad.pagegroup = UDOConstant.personalDetailsPageGroup;
      preQualPageLoad.process_actual_name = this.process_actual_name;
      preQualPageLoad.process_name = this.process_name;
      const tealiumVehicleInfo: any = (window as any).buynow && (window as any).buynow.Tealium
        ? (window as any).buynow.Tealium.vehicleInfo || {}
        : {};
      preQualPageLoad.enh_action = 'add';
      preQualPageLoad.enh_vehic_brand = tealiumVehicleInfo.enh_vehic_brand || '';
      preQualPageLoad.enh_vehic_id = tealiumVehicleInfo.enh_vehic_id || '';
      preQualPageLoad.enh_vehic_name = tealiumVehicleInfo.enh_vehic_name || '';
      preQualPageLoad.enh_vehic_price = tealiumVehicleInfo.enh_vehic_price || '';
      preQualPageLoad.enh_vehic_variant = tealiumVehicleInfo.enh_vehic_variant || '';
      preQualPageLoad.enh_vehic_category = tealiumVehicleInfo.enh_vehic_category || '';
      preQualPageLoad.enh_vehic_discount = tealiumVehicleInfo.enh_vehic_discount && tealiumVehicleInfo.enh_vehic_discount.lockedDiscount
        ? Math.abs(Number(tealiumVehicleInfo.enh_vehic_discount.lockedDiscount)) || 0
        : 0;
      preQualPageLoad.non_interaction = true;
      (window as any).utag_data = preQualPageLoad;
      this.tealium.view((window as any).utag_data);
      // report dynamic yield
      this.dynamicYieldService.track(DynamicYieldEventName.AddToCart, {
        enh_vehic_id: tealiumVehicleInfo.enh_vehic_id,
        enh_vehic_price: tealiumVehicleInfo.enh_vehic_price
      });
      this.dynamicYieldService.track(DynamicYieldEventName.FormLoadPersonalDetails, {
        form_name: FormName.PersonalDetails,
        form_actual_name: FormActualName.PersonalDetails,
        enh_action: checkout_Info.enh_action_add,
        enh_vehic_brand: tealiumVehicleInfo.enh_vehic_brand,
        enh_vehic_category:   preQualPageLoad.enh_vehic_category,
        enh_vehic_discount: preQualPageLoad.enh_vehic_discount,
        enh_vehic_id: tealiumVehicleInfo.enh_vehic_id,
        enh_vehic_list:vehicle_Info.vehic_list,
        enh_vehic_name: tealiumVehicleInfo.enh_vehic_name,
        enh_vehic_price: tealiumVehicleInfo.enh_vehic_price,
        enh_vehic_quantity: vehicle_Info.vehic_quantity,
        enh_vehic_variant: tealiumVehicleInfo.enh_vehic_variant,
        enh_checkout_option:checkout_Info.buyNow_checkout_option,
        enh_checkout_step: checkout_Info.buyNow_checkout_step
      });


    } catch (error) {
      console.log(error);
    }
  }

  /* istanbul ignore next */
  GetCustZipcode() {
    return (document.getElementById('zip_code') ? (document.getElementById('zip_code') as HTMLInputElement).value : '');
  }

}
